import { animated, useSpring, useTransition } from '@react-spring/web';
import { CaretLeftIcon } from '@panwds/icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigationContextV3 } from '../NavigationContextV3/NavigationContextV3.js';
import { getCaretLeftIconClasses, getCollapsedButtonClasses, getIconClasses, getLabelClasses } from './collapse.logic.js';
export function CollapseV3({ changeCollapse, className }) {
    const intl = useIntl();
    const { leftNavCollapsed, collapsed } = useNavigationContextV3();
    const { width } = useSpring({
        width: leftNavCollapsed ? '48px' : '264px',
        config: { mass: 1, tension: 240, friction: 25 }
    });
    const iconSpring = useSpring({
        transform: collapsed ? 'rotateY(180deg)' : 'rotateY(0deg)',
        config: { tension: 240, friction: 20 }
    });
    const titleTransition = useTransition(!leftNavCollapsed, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { duration: 250 }
    });
    return (React.createElement(animated.button, { type: "button", "data-metrics": "primary-nav-collapse-bar", style: { width }, "data-testid": "collapseBar", className: getCollapsedButtonClasses(leftNavCollapsed, className), onClick: changeCollapse, "aria-label": collapsed
            ? intl.formatMessage({
                defaultMessage: 'Expand Navigation',
                id: 'ArQZ2n',
                description: 'Navigation button to expand'
            })
            : intl.formatMessage({
                defaultMessage: 'Collapse Navigation',
                id: 'chAh86',
                description: 'Navigation button to collapse'
            }) },
        React.createElement("div", { className: getIconClasses() },
            React.createElement(animated.div, { style: iconSpring },
                React.createElement(CaretLeftIcon, { size: "xxs", className: getCaretLeftIconClasses() }))),
        titleTransition((style, item) => item && (React.createElement(animated.div, { style: style, className: getLabelClasses() }, intl.formatMessage({
            defaultMessage: 'Toggle Menu',
            id: 'mnqeUT',
            description: 'Collapse button label'
        }))))));
}
//# sourceMappingURL=CollapseV3.js.map